/**
 * Persistência + helpers de UI para mídias de follow-up.
 * parse/serialize: `_shared/followUpMediaUrls` (Edge + app).
 */

export {
  parseMediaUrls,
  serializeMediaUrls,
} from '../../../supabase/functions/_shared/followUpMediaUrls';

export type FollowUpMediaKind = 'image' | 'video' | 'audio' | 'document';

export function guessMediaKind(url: string): FollowUpMediaKind {
  const clean = url.split('?')[0].toLowerCase();
  if (/\.(png|jpe?g|gif|webp|bmp|heic)$/.test(clean)) return 'image';
  if (/\.(mp4|mov|webm|m4v)$/.test(clean)) return 'video';
  if (/\.(mp3|ogg|oga|m4a|wav|aac|opus)$/.test(clean)) return 'audio';
  return 'document';
}

export function fileNameFromUrl(url: string): string {
  try {
    const path = new URL(url).pathname;
    const name = decodeURIComponent(path.split('/').pop() || '');
    return name || 'arquivo';
  } catch {
    const name = url.split('?')[0].split('/').pop() || '';
    return decodeURIComponent(name) || 'arquivo';
  }
}
